import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Tabs from './Tabs';

const TabsPicker = (props) => {
  const { pageContentResource } = usePageContentContext();

  if (pageContentResource.attr('tabs') && pageContentResource.attr('tabs').resources().length() > 0) {
    return <Tabs {...props} />;
  }

  return null;
};

export default TabsPicker;
